module.exports = "{{each variants}}\n<div class=\"link-order-row\">\n\t<div class=\"link-order-label\">\n\t\t${$value.name}:\n\t\t<span class=\"req_star\">*</span>\n\t</div>\n\t<div class=\"has-select link-order-label\">\n\t\t<select name=\"attr${$index}\" pattr=\"${$value.name}\">\n\t\t\t<option value=\"\">Выберите...</option>\n\t\t\t{{each $value.variants}}\n\t\t\t<option value=\"${$value}\">${$value}</option>\n\t\t\t{{/each}}\n\t\t</select>\n\t</div>\n\t<div name=\"attr${$index}_error\"></div>\n</div>\n{{/each}}\n"


//////////////////
// WEBPACK FOOTER
// ./modules/packages/create_order/templates/variants-simple.html
// module id = qcNp
// module chunks = 2 3 4 5 6 11